<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="languages">
	<ng-container *ngTemplateOutlet="flagImage; context: { $implicit: activeLang }"></ng-container>
</button>

<!-- Language menu -->
<mat-menu [xPosition]="'before'" #languages="matMenu">
	<ng-container *ngFor="let language of scope.languages; trackBy: trackByFn">
		<button mat-menu-item (click)="setActiveLang(language)">
			<span class="flex items-center">
				<img
					class="w-full"
					[src]="'assets/images/flags/' + flagCodes[language].toUpperCase() + '.svg'"
					[alt]="language | findLanguageFromKey" />
				<span class="ml-3">{{ language | findLanguageFromKey }}</span>
			</span>
		</button>
	</ng-container>
</mat-menu>

<!-- Flag image template -->
<ng-template let-language #flagImage>
	<span class="relative w-6 shadow rounded-sm overflow-hidden">
		<span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
		<img
			class="w-full"
			[src]="'assets/images/flags/' + flagCodes[language].toUpperCase() + '.svg'"
			[alt]="language" />
	</span>
</ng-template>
